/* eslint-disable max-lines */
import { ACTION, CATEGORY, DataLayer, EVENT } from 'src/utils/google-analytics'
import request from '@hotmart/request'

import { GROUP } from 'src/utils/datahub'
import myPanelSVG from '../../assets/panel.svg'
import myProductsSVG from '../../assets/products.svg'
import mySalesSVG from '../../assets/sales.svg'
import balanceSVG from '../../assets/balance.svg'
import clubSVG from '../../assets/club.svg'
import membersAreaSVG from '../../assets/members-area.svg'
import paymentsPageSVG from '../../assets/payments-page.svg'
import affiliatesProgramSVG from '../../assets/affiliates-program.svg'
import affiliationMarketSVG from '../../assets/affiliation-market.svg'
import customerSegmentationSVG from '../../assets/customer-segmentation.svg'
import spacesSVG from '../../assets/spaces.svg'
import klickpagesSVG from '../../assets/klickpages.svg'
import klicksendSVG from '../../assets/klicksend.svg'
import webinarSVG from '../../assets/webinar.svg'
import myExtensionsSVG from '../../assets/my-extensions.svg'
import linkManagerSVG from '../../assets/linkManager.svg'
import affiliateToolsSVG from '../../assets/affiliate-tools.svg'
import trackingPixelSVG from '../../assets/pixel-de-rastreamento.svg'
import reportsSVG from '../../assets/menu-reports.svg'

import './dynamic.requests'
import { MenuItem } from './dynamic.types'

const klickAuthRequest = async type => {
  request('pro.integration.login', { page: type }).then(response => window.open(response)?.focus())
}

const menuItems: Record<string, MenuItem> = {
  my_panel: {
    title: 'header.menu.dynamic_menu.my_panel',
    route: '/dashboard',
    icon: myPanelSVG,
    testid: 'my_panel',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'MyPanel')],
    dataHubEvents: [
      {
        name: 'MyPanel',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  my_products: {
    title: 'header.menu.dynamic_menu.my_products',
    route: '/products',
    icon: myProductsSVG,
    testid: 'my_products',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'MyProducts')],
    dataHubEvents: [
      {
        name: 'MyProducts',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  my_sales: {
    title: 'header.menu.dynamic_menu.my_sales',
    route: '/sales',
    icon: mySalesSVG,
    testid: 'my_sales',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'MySales')],
    dataHubEvents: [
      {
        name: 'MySales',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  member_area: {
    title: 'header.menu.dynamic_menu.course_management',
    route: '/members-area',
    icon: membersAreaSVG,
    testid: 'member_area',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'MembersArea')],
    dataHubEvents: [
      {
        name: 'MembersArea',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  balance: {
    title: 'header.menu.dynamic_menu.balance',
    route: '/payouts',
    icon: balanceSVG,
    testid: 'balance',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Balance')],
    dataHubEvents: [
      {
        name: 'Balance',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  club_membership: {
    title: 'header.menu.dynamic_menu.club_membership',
    route: '/membership/list',
    icon: clubSVG,
    testid: 'club_membership',
    isBeta: true,
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Club')],
    dataHubEvents: [
      {
        name: 'ClubMembership',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  payment_page_config: {
    title: 'header.menu.dynamic_menu.payments_page',
    route: '/products/manage/_/tools/checkout/settings',
    icon: paymentsPageSVG,
    testid: 'payment_page_config',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'PaymentsPage')
    ],
    dataHubEvents: [
      {
        name: 'PaymentsPage',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'payment_page_config',
        group: GROUP.TOOLS
      }
    ]
  },
  space: {
    title: 'header.menu.dynamic_menu.spaces',
    route: `${process.env.URL_SPACE}/create/space`,
    icon: spacesSVG,
    testid: 'space',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Spaces')],
    dataHubEvents: [
      {
        name: 'Spaces',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  affiliate_program: {
    title: 'header.menu.dynamic_menu.affiliate_program',
    route: '/products/manage/_/affiliates-program',
    icon: affiliatesProgramSVG,
    testid: 'affiliate_program',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'AffiliateProgram')
    ],
    dataHubEvents: [
      {
        name: 'AffiliateProgram',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'affiliate_program',
        group: GROUP.TOOLS
      }
    ]
  },
  affiliation_market: {
    title: 'header.menu.dynamic_menu.affiliation_market',
    route: '/market',
    icon: affiliationMarketSVG,
    testid: 'affiliation_market',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'AffiliationMarket')
    ],
    dataHubEvents: [
      {
        name: 'AffiliationMarket',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  affiliate_tools: {
    title: 'header.menu.dynamic_menu.affiliate_tools',
    route: '/tools/list/affiliate',
    icon: affiliateToolsSVG,
    testid: 'affiliate_tools',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'AffiliateTools')
    ],
    dataHubEvents: [
      {
        name: 'AffiliateTools',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  tools: {
    title: 'header.menu.dynamic_menu.affiliate_tools',
    route: '/tools',
    icon: affiliateToolsSVG,
    testid: 'tools',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'AllTools')],
    dataHubEvents: [
      {
        name: 'AllTools',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  listboss: {
    title: 'header.menu.dynamic_menu.customer_segmentation',
    route: '/tools/manage/_/listboss',
    icon: customerSegmentationSVG,
    testid: 'listboss',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'CustomerSegmentation')
    ],
    dataHubEvents: [
      {
        name: 'ListBoss',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'listboss',
        group: GROUP.TOOLS
      }
    ]
  },
  link_manager: {
    title: 'header.menu.dynamic_menu.link_manager',
    route: '/shortener',
    icon: linkManagerSVG,
    testid: 'link_manager',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'LinkManager')],
    dataHubEvents: [
      {
        name: 'LinkManager',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  tracking_pixel: {
    title: 'header.menu.dynamic_menu.tracking_pixel',
    route: '/tools/pixel',
    icon: trackingPixelSVG,
    testid: 'tracking_pixel',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'TrackingPixel')
    ],
    dataHubEvents: [
      {
        name: 'TrackingPixel',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  my_extensions: {
    title: 'header.menu.dynamic_menu.my_extensions',
    route: process.env.URL_EXTENSIONS || '',
    icon: myExtensionsSVG,
    testid: 'my_extensions',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Discover_extensions')
    ],
    dataHubEvents: [
      {
        name: 'MyExtensions',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  },
  klickpages: {
    title: 'header.menu.dynamic_menu.klickpages',
    route: async () => klickAuthRequest('KLICK_PAGES'),
    icon: klickpagesSVG,
    testid: 'klickpages',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Klickpages'),
      new DataLayer(EVENT.ENGAGEMENT, CATEGORY.FREQUENCY, ACTION.CLICK_MENU_TOOLS, 'Klickpages')
    ],
    dataHubEvents: [
      {
        name: 'Klickpages',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'klickpages',
        group: GROUP.TOOLS
      }
    ]
  },
  klicksend: {
    title: 'header.menu.dynamic_menu.klicksend',
    route: async () => klickAuthRequest('KLICK_SEND'),
    icon: klicksendSVG,
    testid: 'klicksend',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Klicksend'),
      new DataLayer(EVENT.ENGAGEMENT, CATEGORY.FREQUENCY, ACTION.ACCESS_KLICKSEND, 'Klicksend')
    ],
    dataHubEvents: [
      {
        name: 'Klicksend',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'klicksend',
        group: GROUP.TOOLS
      }
    ]
  },
  webinar: {
    title: 'header.menu.dynamic_menu.webinar',
    route: `${process.env.URL_WEBINAR}`,
    icon: webinarSVG,
    testid: 'webinar',
    dataLayerEvents: [
      new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Webinar'),
      new DataLayer(EVENT.ENGAGEMENT, CATEGORY.FREQUENCY, ACTION.ACCESS_WEBINAR, 'Webinar')
    ],
    dataHubEvents: [
      {
        name: 'Webinar',
        group: GROUP.UNIVERSALBAR_TOOLS
      },
      {
        name: 'webinar',
        group: GROUP.TOOLS
      }
    ]
  },
  reports: {
    title: 'header.menu.dynamic_menu.reports',
    route: '/reports',
    icon: reportsSVG,
    testid: 'reports',
    dataLayerEvents: [new DataLayer(EVENT.INTERACTION, CATEGORY.UNIVERSAL_BAR, ACTION.CLICK_MENU_TOOLS, 'Reports')],
    dataHubEvents: [
      {
        name: 'Reports',
        group: GROUP.UNIVERSALBAR_TOOLS
      }
    ]
  }
}

export { menuItems }
